import { VisualNode } from './visual-node';

export class LayerManager {
    public static zIndexRootNode: number = 0;
    public static zIndexTeamNode: number = 5;
    public static zIndexOther: number = 10;

    private nodes: VisualNode[] = [];

    constructor() {}

    public addNode(v: VisualNode) {
        this.nodes.push(v);
    }

    public drawInOrder() {
        this.nodes.sort((n1, n2) => n1.zIndex - n2.zIndex).forEach(v => v.init());
    }
}
